import React from 'react';

import {TableEditHora} from "./components/hora/TableEditHora";
import { TableHora} from "./components/hora/TableHora";

export const SeccionHora = ({tipo, data, factura, reload}) => {
    return (
        <div className="mb-12">
            {tipo === 'S' && <TableHora  liquidacion={data}  factura={factura}  reload={reload} />}
            {tipo === 'N' && <TableEditHora liquidacion={data}  factura={factura} reload={reload} />}
        </div>
    )
};


